import { ChevronUp, ChevronDown } from 'lucide-react';

/**
 * Boutons ▲ / ▼ pour déplacer une ligne du layout d'un cran, en complément
 * du drag & drop (peu fiable au doigt dans un tableau qui scrolle).
 *
 * Props :
 *   onMove   (delta: -1 | 1) => void
 *   isFirst  boolean — désactive ▲
 *   isLast   boolean — désactive ▼
 */
export default function MoveButtons({ onMove, isFirst = false, isLast = false }) {
  const base =
    'shrink-0 flex items-center justify-center w-6 h-5 rounded text-slate-400 hover:text-slate-700 hover:bg-slate-200 disabled:opacity-25 disabled:hover:bg-transparent disabled:cursor-default transition-colors';
  return (
    <div className="shrink-0 flex flex-col -my-1">
      <button
        type="button"
        onClick={() => onMove(-1)}
        disabled={isFirst}
        aria-label="Monter cette ligne"
        className={base}
      >
        <ChevronUp size={13} />
      </button>
      <button
        type="button"
        onClick={() => onMove(1)}
        disabled={isLast}
        aria-label="Descendre cette ligne"
        className={base}
      >
        <ChevronDown size={13} />
      </button>
    </div>
  );
}
